"use strict";
const InvoiceAbandonerRadioGroup = ({
  duplicateInvoice,
  onChangeOption,
  selectedOption
}) => {
  const invoiceNumber = duplicateInvoice.number;
  const amount = parseFloat(duplicateInvoice.source_invoice_amount).toFixed(2);
  const carrier = duplicateInvoice.carrier_name;
  const duplicateInvoiceText = `Duplicate of Invoice ${invoiceNumber} for $${amount} from ${carrier}`;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "row ignore-entry-view__radio-option" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      checked: selectedOption === "duplicate-invoice",
      id: "duplicate-invoice",
      onChange: onChangeOption,
      type: "radio",
      value: "duplicate-invoice"
    }
  ), /* @__PURE__ */ React.createElement("label", { htmlFor: "duplicate-invoice" }, duplicateInvoiceText)), /* @__PURE__ */ React.createElement("div", { className: "row ignore-entry-view__radio-option" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      checked: selectedOption === "ignore",
      id: "ignore",
      onChange: onChangeOption,
      type: "radio",
      value: "ignore"
    }
  ), /* @__PURE__ */ React.createElement("label", { htmlFor: "ignore" }, "Other")));
};
export default InvoiceAbandonerRadioGroup;
